// ScrollToTop.tsx
import { useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
    const { pathname, hash } = useLocation();
    useLayoutEffect(() => {
        if (!hash) {
            window.scrollTo(0, 0);
        }
        // When hash is present, useHashScroll handles scrolling to the target element
    }, [pathname, hash]);

    return null;
};

export default ScrollToTop;
